import { defineMessages } from 'react-intl';

const scope = 'app.containers.Statistics';

export default defineMessages({
    header: {
        id: `${scope}.header`,
        description: 'The main title of the Statistics page',
        defaultMessage: 'Statistics',
    },
});
